import React, { Component } from 'react';


import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import {CCActions} from './../../cc-imports'

class VerifyEmail extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };
        this._signUpGoogle=this._signUpGoogle.bind(this)
    }

    _signUpGoogle(){
        //this.props.actions.signIn(this.props.actions.getUserByEmail);
    }

    render(){
        return (
            <div className="row">
                <div className="col-sm-4"></div>
                <div className="col-sm-4">
                    Verify email
                </div>
                <div className="col-sm-4"></div>
            </div>
        );
    }
}


export default connect(state=>({
    //user: state.user.user,
}), (dispatch)=>({
    actions: bindActionCreators({...CCActions}, dispatch),
    dispatch: dispatch
}))(VerifyEmail);


// WEBPACK FOOTER //
// ./src/app/routes/VerifyEmail/VerifyEmail.js